import * as R from 'ramda'
import { API_CONST } from '../middlewares/api'

import { handleActions, createAction } from 'redux-actions'

const initial = {
  state: 'login',
  loginId: null,
  userId: null,
  user: null,
  isLogged: false,
  settings: null,
  error: null,
  __data: {}
}

const generateActions = prefix => ([ `${prefix}/START`, `${prefix}/SUCCESS`, `${prefix}/FAILURE` ])

const authActions = generateActions('auth/auth')
const logoutActions = generateActions('auth/logout')
const claimLotActions = generateActions('auth/claimLot')
const setNameActions = generateActions('auth/setName')
const requestCodeActions = generateActions('auth/requestCode')
const confirmCodeActions = generateActions('auth/confirmCode')
const getUserActions = generateActions('auth/getUser')
const socialAuthActions = generateActions('auth/socialAuth')

export const logIn = createAction(API_CONST, (login, userId) => ({
  method: 'post',
  url: 'auth/app',
  params: { login, userId },
  actions: authActions
}))

export const logInSocial = createAction(API_CONST, (provider, data = {}) => ({
  method: 'post',
  url: '../auth/oauthCheck',
  actions: socialAuthActions,
  params: { provider, data }
}))

export const logOut = createAction(API_CONST, login => ({
  method: 'post',
  url: 'auth/logout',
  actions: logoutActions
}))

export const requestCode = createAction(API_CONST, userLoginId => ({
  actions: requestCodeActions,
  url: `auth/app/auth/${userLoginId}`
}))

export const confirmCode = createAction(API_CONST, (userLoginId, codeValue) => ({
  method: 'post',
  params: { codeValue },
  actions: confirmCodeActions,
  url: `auth/app/auth/${userLoginId}`
}))

export const setName = createAction(API_CONST, (userId, data, code) => ({
  method: 'post',
  actions: setNameActions,
  params: { ...data, lastCode: code },
  url: `auth/app/username/${userId}/`
}))

export const getUser = createAction(API_CONST, () => ({
  actions: getUserActions,
  url: `auth/user`
}))

export const setState = createAction('auth/SET_STATE', state => ({ state }))

// ------------ //

const getUserSettingsActions = generateActions('auth/getUserSettings')

export const claimAsLot = createAction(API_CONST, description => ({
  method: 'POST',
  params: { description },
  actions: claimLotActions,
  url: `auth/info/offerLot`
}))

export const getUserSettings = createAction(
  API_CONST,
  () => ({
    url: 'auth/info/settings',
    actions: getUserSettingsActions
  })
)

export const setUserSettings = createAction(
  API_CONST,
  (data = {}) => ({
    params: data,
    method: 'POST',
    url: 'auth/info/settings',
    actions: getUserSettingsActions
  })
)

// ------------ //

export const clearAuthData = createAction('auth/CLEAR_AUTH_DATA', () => null)
export const clearError = createAction('auth/CLEAR_AUTH_ERROR')

// ------------ //

const reduceUserError = (state, { payload }) => {
  // get error message if any
  const error = R.pathOr(null, [ 'payload', 'message', 'response', 'data', 'error' ], payload)

  // if error code !== 403, return default error state
  if (payload.status !== 403) return ({ ...state, error })

  // else, get response data
  const data = R.pathOr({}, [ 'message', 'response', 'data', 'data' ], payload)

  return ({ ...state, error, userId: data.userId, state: 'set', __data: R.pick([ 'email', 'phone', 'name', 'surname' ], data) })
}

// ------------ //

export default handleActions({
  [clearError]: state => ({ ...state, error: null }),
  [clearAuthData]: state => ({ ...state, state: 'login', loginId: null, userId: null }),
  [authActions[0]]: state => ({ ...state, error: null }),
  [authActions[1]]: (state, { payload }) => ({ ...state, loginId: payload.userLoginId }),
  [authActions[2]]: (state, { payload }) => ({ ...state, error: payload.message.response.data.error }),
  //
  [requestCodeActions[0]]: state => ({ ...state, error: null }),
  [requestCodeActions[1]]: state => ({ ...state, state: 'confirm' }),
  [requestCodeActions[2]]: (state, { payload }) => ({ ...state, error: payload.message.response.data.error }),
  //
  [confirmCodeActions[0]]: state => ({ ...state, error: null }),
  [confirmCodeActions[1]]: state => ({ ...state, state: 'logged' }),
  [confirmCodeActions[2]]: reduceUserError,
  //
  [setNameActions[0]]: state => ({ ...state, error: null }),
  [setNameActions[1]]: state => ({ ...state, state: 'logged' }),
  [setNameActions[2]]: (state, { payload }) => ({ ...state, error: payload.message.response.data.error }),
  //
  [setState]: (state, { payload }) => ({ ...state, state: payload.state }),
  //
  [getUserActions[0]]: state => ({ ...state, error: null }),
  [getUserActions[1]]: (state, { payload }) => ({ ...state, isLogged: !!payload, user: payload || null }),
  [getUserActions[2]]: (state, { payload }) => ({ ...state, error: payload.message.response.data.error }),
  //
  [socialAuthActions[1]]: (state, { payload }) => ({ ...state, isLogged: !!payload, user: payload || null }),
  [socialAuthActions[2]]: reduceUserError,
  //
  [logoutActions[1]]: () => ({ ...initial }),
  //
  [getUserSettingsActions[0]]: state => ({ ...state, settings: null, error: null }),
  [getUserSettingsActions[2]]: (state, { payload }) => ({ ...state, settings: null, error: payload.message.response.data.error }),
  [getUserSettingsActions[1]]: (state, { payload }) => ({ ...state, settings: payload })
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/auth.js